import React, { useEffect, useMemo, useState } from "react";
import { Skeleton } from "antd";
import './RandomSamplingTable.css'

/* ---------------- Skeleton Loader ---------------- */
const TableSkeleton = ({ rows = 6, columns = 6 }) => {
  return (
    <div className="p-4">
      {[...Array(rows)].map((_, r) => (
        <div key={r} className="flex gap-3 mb-3">
          {[...Array(columns)].map((_, c) => (
            <Skeleton.Input
              key={c}
              active
              size="small"
              style={{ width: 120 }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

/* ---------------- Main Table ---------------- */
const RandomSamplingTable = ({ samplingPayload = [] }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  /* Load data */
  useEffect(() => {
    setLoading(true);
    setData(samplingPayload || []);
    setLoading(false);
  }, [samplingPayload]);

  /* Compute ordered columns ONCE */
  const orderedHeaders = useMemo(() => {
    if (!data.length) return [];

    const priorityKeys = ["Record_ID", "name"];

    const headers = Array.from(
      new Set(data.flatMap((row) => Object.keys(row)))
    );

    const orderedHeaders = [
      ...priorityKeys.filter((k) => headers.includes(k)),
      ...headers.filter((k) => !priorityKeys.includes(k)),
    ];


    return orderedHeaders;
  }, [data]);

  /* Loading state */
  if (loading) {
    return <TableSkeleton rows={16} columns={9} />;
  }

  /* Empty state */
  if (!data.length) {
    return <p className="p-4">No data available</p>;
  }

  return (
    <div className="h-[600px] overflow-auto random-sampling-table scrollbar-thin scrollbar-thumb-gray-600">
      <table className="w-full min-w-[900px] border-separate border-spacing-0 table-fixed">
        <thead>
          <tr>
            {orderedHeaders.map((header) => (
              <th
                key={header}
                className="sticky top-0 z-20 bg-gray-900 !text-white border border-gray-700 
                     px-3 py-2 text-left 
                     w-[180px] max-w-[180px] truncate whitespace-nowrap overflow-hidden"
                title={header}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, i) => (
            <tr key={i} className="hover:bg-gray-800">
              {orderedHeaders.map((header) => (
                <td
                  key={header}
                  className="border border-gray-700 !text-white 
                       px-3 py-2 
                       w-[180px] max-w-[180px] truncate whitespace-nowrap overflow-hidden"
                  title={row[header]} // tooltip on hover
                >
                  {row[header] ?? "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RandomSamplingTable;